import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

import AreaInfo from '../../AreaInfo';

const messages = defineMessages({
  noInfo: {
    // Id em inglês curto para facilitar reutilização e evitar espaços
    id: 'areaNoInfo',
    // English default; add PT/ES translations in .po files.
    defaultMessage: 'This area has no registered information',
  },
});

const AreaInfoBody = (props) => {
  const intl = useIntl();
  const { content, isEditMode } = props; // conteúdo da página Area

  const { description, competencies, address_and_hours } = content;

  if (!description && !competencies && !address_and_hours && isEditMode) {
    return (
      <div className="text-danger text-center">
        {intl.formatMessage(messages.noInfo)}
      </div>
    );
  }

  return (
    <div className="mb-4">
      <AreaInfo areaData={content} showTitle={false} />
    </div>
  );
};

AreaInfoBody.propTypes = {
  content: PropTypes.object,
};

export default AreaInfoBody;
